import { Badge } from "plos/src/components/Badge";
import ButtonLink from "plos/src/components/links/ButtonLink";
import { useTranslation } from "react-i18next";
import { ChevronRight } from "../../icons/Chevrons";
import { getLeagueUrl } from "../../leagues/utils";
import EntryInfoPanel from "../EntryInfoPanel";
import { fanLeagueBadge } from "./fanLeague.css";
import { FanLeagueProps } from "./types";

const FanLeague = ({ fanLeagueData }: FanLeagueProps) => {
  const { t } = useTranslation();
  if (!fanLeagueData?.league || !fanLeagueData?.team) {
    return null;
  }
  const headerAction = (
    <ButtonLink
      appearance="tonal"
      size="small"
      to={getLeagueUrl(fanLeagueData.league.id, fanLeagueData.league.scoring)}
    >
      {t("fanLeague.viewLeague", "View League")}
      <ChevronRight height={10} width={10} />
    </ButtonLink>
  );

  return (
    <EntryInfoPanel
      title={t("fanLeague.title", "Fan League")}
      headerAction={headerAction}
    >
      <div className={fanLeagueBadge}>
        <Badge team={fanLeagueData.team} />
      </div>
    </EntryInfoPanel>
  );
};

export default FanLeague;
